import { Calendar } from "@amir04lm26/react-modern-calendar-date-picker";
import moment from "moment-jalaali";
import React, { useEffect, useState } from "react";
import { Link, NavLink, Route, Routes, useNavigate } from "react-router-dom";
import { postGuest } from "../../../services/postApi";
import { getRoomPrices } from "../../../services/roomPriceApi";
import {
  covertToDateCalender,
  covertToDateValue,
  getNumber,
  lenthTime,
  splitNumber,
} from "../../../utils/helper";

/* eslint-disable jsx-a11y/anchor-is-valid */
function Guest() {
  const redirect = useNavigate();
  const [data, setData] = React.useState({
    fullname: "-",
    number_room: "-",
    city: "-",
    phone: "-",
    type_room: "-",
    login_date: "-",
    logout_date: "-",
    price_room: 0,
    stay_time: "-",
    discount: 0,
    description: "بدون شرح",
    price: 0,
  });

  const [dateTime, setDateTime] = React.useState({ date1: "-", date2: "-" });
  const [discountINpt, setDiscount] = React.useState(0);
  const [btn, setBtn] = useState("");
  const [sepecial, setSpecial] = React.useState(false);

  const [selectedDayRange, setSelectedDayRange] = useState({
    from: null,
    to: null,
  });

  React.useMemo(() => {
    let d1 = moment(
      covertToDateValue(selectedDayRange.from),
      "jYYYY/jM/jD"
    ).format("YYYY/M/D");
    let d2 = moment(
      covertToDateValue(selectedDayRange.to),
      "jYYYY/jM/jD"
    ).format("YYYY/M/D");
    let totalPrice = data.price_room * lenthTime(d1, d2);
    setDiscount(0);

    setData({
      ...data,
      stay_time: lenthTime(d1, d2),
      discount: 0,
      price: Math.floor(totalPrice),
    });

    setDateTime({
      date1: covertToDateValue(selectedDayRange.from),
      date2: covertToDateValue(selectedDayRange.to),
    });
  }, [selectedDayRange]);

  function slect(s, p, type) {
    setBtn(s);
    let totalPrice = p * data.stay_time;
    setData({
      ...data,
      price_room: p,
      type_room: type,
      price: Math.floor(totalPrice),
      discount: Math.floor((discountINpt / data.price) * 100),
    });
  }

  let {
    fullname,
    number_room,
    city,
    phone,
    type_room,
    login_date,
    logout_date,
    price_room,
    stay_time,
    discount,
    price,
  } = data;

  const getValueChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  React.useMemo(() => {
    let totalPrice = data.price_room * data.stay_time;
    setData({
      ...data,
      price: Math.floor(totalPrice - discountINpt),
      discount: Math.round((discountINpt / data.price) * 100),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [discountINpt]);

  function handleSubmit(e) {
    let dataSubmit = {
      fullname: data.fullname,
      isSpecial: sepecial,
      number_room: data.number_room,
      city: data.city,
      phone: data.phone,
      login_date: dateTime.date1,
      logout_date: dateTime.date2,
      price_room: data.price_room,
      stay_time: data.stay_time,
      discount: !discount ? 1 : data.discount,
      description: data.description,
      price: data.price,
    };
    postGuest(dataSubmit)
      .then((res) => {
        redirect("/");
      })
      .catch((err) => console.log(err));
  }

  return (
    <div className="w-[90%] m-auto page-ani">
      {/* Info Card */}
      <div className="flex items-center justify-center p-4">
        <div className="glass bg-gradient-to-br from-base-300/80 to-base-200/50 rounded-2xl shadow-2xl p-6 w-full">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {/* Column 1 */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-primary/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">نام کامل</p>
                  <p className="font-bold text-white">{fullname}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-secondary/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">شماره اتاق</p>
                  <p className="font-bold text-white">{number_room}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-accent/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">شماره تلفن</p>
                  <p className="font-bold text-white">{phone}</p>
                </div>
              </div>
            </div>

            {/* Column 2 */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-info/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-info" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">شهر</p>
                  <p className="font-bold text-white">{city}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-success/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-success" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">تاریخ ورود</p>
                  <p className="font-bold text-white">{dateTime.date1}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-error/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-error" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">تاریخ خروج</p>
                  <p className="font-bold text-white">{dateTime.date2}</p>
                </div>
              </div>
            </div>

            {/* Column 3 */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-warning/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-warning" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">مدت اقامت</p>
                  <p className="font-bold text-white">{stay_time} روز</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-purple-500/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-purple-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">نوع اتاق</p>
                  <p className="font-bold text-white">{type_room}</p>
                </div>
              </div>
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-emerald-500/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-emerald-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">هزینه اتاق</p>
                  <p className="font-bold text-white">{price_room.toLocaleString()} تومان</p>
                </div>
              </div>
            </div>

            {/* Column 4 - Total Price */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2 bg-base-200/50 rounded-lg p-3">
                <div className="w-8 h-8 bg-rose-500/20 rounded-lg flex items-center justify-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-rose-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                  </svg>
                </div>
                <div>
                  <p className="text-xs text-gray-400">تخفیف</p>
                  <p className="font-bold text-white">{discount} %</p>
                </div>
              </div>
              <div className="bg-gradient-to-br from-primary to-secondary rounded-xl p-4 flex flex-col justify-center items-center">
                <p className="text-sm text-white/80">هزینه کل</p>
                <p className="text-2xl font-bold text-white">{!price ? 0 : price.toLocaleString()}</p>
                <p className="text-xs text-white/60">تومان</p>
              </div>
              <button 
                className="btn btn-success gap-2 w-full shadow-lg hover:scale-[1.02] transition-transform" 
                onClick={handleSubmit}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-check-circle" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z" />
                </svg>
                تایید و ارسال
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div className="tabs tabs-boxed justify-center mt-4 bg-base-300/50 p-1 rounded-xl">
        <NavLink
          className={({ isActive }) =>
            isActive ? "tab btn-ani tab-active bg-primary text-white" : "tab btn-ani hover:bg-base-200"
          }
          to="./person"
        >
          مشخصات فردی
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive ? "tab btn-ani tab-active bg-primary text-white" : "tab btn-ani hover:bg-base-200"
          }
          to="./room"
        >
          مشخصات اقامتی
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            isActive ? "tab btn-ani tab-active bg-primary text-white" : "tab btn-ani hover:bg-base-200"
          }
          to="./check"
        >
          تخفیف
        </NavLink>
      </div>

      <div className="mt-5">
        <Routes path="new-guest">
          <Route
            path="/person"
            element={<Person getValueChange={getValueChange} />}
          />
          <Route
            path="room"
            element={
              <Room
                getValueChange={getValueChange}
                btn={btn}
                selectedDayRange={selectedDayRange}
                setSelectedDayRange={setSelectedDayRange}
                slect={slect}
              />
            }
          />
          <Route
            path="check"
            element={
              <Descount
                setSpecial={setSpecial}
                getValueChange={getValueChange}
                setData={setData}
                data={data}
                setDiscount={setDiscount}
                discountINpt={discountINpt}
              />
            }
          />
        </Routes>
      </div>
    </div>
  );
}

function Person({ getValueChange }) {
  return (
    <div className="flex items-center p-3 pt-5 justify-center w-[80%] m-auto flex-wrap page-ani">
      <div className="flex items-center w-full gap-3">
        <div className="flex-1">
          <label className="label">
            <span className="label-text text-gray-400">نام و نام خانوادگی</span>
          </label>
          <div className="relative">
            <input
              type="text"
              name="fullname"
              onChange={getValueChange}
              placeholder="نام کامل را وارد کنید"
              className="input input-bordered w-full bg-base-200/50 focus:input-primary"
            />
            <div className="absolute left-3 top-1/2 -translate-y-1/2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
          </div>
        </div>
        <div className="w-40">
          <label className="label">
            <span className="label-text text-gray-400">شماره اتاق</span>
          </label>
          <input
            type="number"
            name="number_room"
            onChange={getValueChange}
            placeholder="شماره"
            className="input input-bordered w-full bg-base-200/50 focus:input-primary"
          />
        </div>
      </div>
      <div className="flex items-center w-full gap-3 mt-3">
        <div className="flex-1">
          <label className="label">
            <span className="label-text text-gray-400">شماره تلفن</span>
          </label>
          <input
            type="text"
            name="phone"
            onChange={getValueChange}
            placeholder="شماره تماس"
            className="input input-bordered w-full bg-base-200/50 focus:input-primary"
          />
        </div>
        <div className="flex-1">
          <label className="label">
            <span className="label-text text-gray-400">شهر</span>
          </label>
          <input
            type="text"
            name="city"
            onChange={getValueChange}
            placeholder="نام شهر"
            className="input input-bordered w-full bg-base-200/50 focus:input-primary"
          />
        </div>
      </div>
    </div>
  );
}

function Room({
  getValueChange,
  btn,
  selectedDayRange,
  setSelectedDayRange,
  slect,
}) {
  const [open, setOpen] = useState(false);
  const [roomPrices, setRoomPrices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRoomPrices();
  }, []);

  const fetchRoomPrices = async () => {
    try {
      const response = await getRoomPrices();
      setRoomPrices(response.data || []);
    } catch (err) {
      console.error('Error fetching room prices:', err);
    } finally {
      setLoading(false);
    }
  };

  function handleOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <div className="flex items-center p-3 pt-5 justify-start w-[80%] m-auto flex-wrap page-ani">
      <div
        onClick={handleClose}
        className={`fixed w-full h-[100vh] left-0 top-0 bg-[#0001] z-[100] backdrop-blur-sm ${
          !open ? "hidden" : "block"
        }`}
      ></div>
      <div
        className={`flex items-center w-full relative ${
          !open ? "calendar-close" : "calendar-open"
        }`}
      >
        <div className="flex-1">
          <label className="label">
            <span className="label-text text-gray-400">تاریخ ورود</span>
          </label>
          <input
            defaultValue={
              selectedDayRange.from && covertToDateValue(selectedDayRange.from)
            }
            onFocus={handleOpen}
            type="text"
            placeholder="انتخاب تاریخ ورود"
            name="login_date"
            onChange={getValueChange}
            className="input input-bordered w-full bg-base-200/50 focus:input-primary"
          />
        </div>
        <div className="mx-4 mt-8 text-gray-400">تا</div>
        <div className="flex-1">
          <label className="label">
            <span className="label-text text-gray-400">تاریخ خروج</span>
          </label>
          <input
            defaultValue={
              selectedDayRange.to && covertToDateValue(selectedDayRange.to)
            }
            onFocus={handleOpen}
            type="text"
            name="logout_date"
            placeholder="انتخاب تاریخ خروج"
            onChange={getValueChange}
            className="input input-bordered w-full bg-base-200/50 focus:input-primary"
          />
        </div>
        <Calendar
          value={selectedDayRange}
          onChange={setSelectedDayRange}
          shouldHighlightWeekends
          locale="fa"
        />
      </div>
      <div className="flex items-center justify-center w-full m-2 mt-8 flex-col">
        <label className="label self-start">
          <span className="label-text text-gray-400 font-medium">انتخاب نوع اتاق</span>
        </label>
        {loading ? (
          <div className="flex justify-center py-4">
            <span className="loading loading-spinner loading-md text-primary"></span>
          </div>
        ) : (
          <div className="flex flex-wrap gap-2 justify-center">
            {roomPrices.map((room, index) => (
              <button
                key={room._id}
                className={`btn gap-2 ${btn === index + 1 ? "btn-primary" : "btn-outline"}`}
                onClick={(e) =>
                  slect(
                    index + 1,
                    room.price,
                    room.roomType
                  )
                }
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                {room.roomType}
                <span className="badge badge-sm">{room.price.toLocaleString()}</span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function Descount({
  getValueChange,
  data,
  setData,
  discountINpt,
  setDiscount,
  setSpecial,
}) {
  return (
    <div className="flex items-start p-3 pt-5 justify-center w-[80%] m-auto flex-wrap page-ani">
      <div className="flex items-start w-full gap-4">
        <div className="flex-1">
          <label className="label">
            <span className="label-text text-gray-400">شرح و توضیحات</span>
          </label>
          <textarea
            type="text"
            name="description"
            onChange={getValueChange}
            placeholder="توضیحات اختیاری..."
            className="textarea textarea-bordered w-full h-[200px] bg-base-200/50 focus:textarea-primary"
          />
        </div>
        <div className="w-64">
          <label className="label">
            <span className="label-text text-gray-400">مبلغ تخفیف</span>
          </label>
          <div className="flex items-center gap-2">
            <input
              type="number"
              name="number_room"
              onFocus={getNumber}
              autoFocus
              onBlur={splitNumber}
              onChange={(e) => setDiscount(parseInt(e.target.value))}
              placeholder="مبلغ"
              className="input input-bordered w-full bg-base-200/50 focus:input-primary"
            />
            <span className="text-gray-400">تومان</span>
          </div>
          <div className="form-control mt-5">
            <label className="label cursor-pointer justify-start gap-3">
              <input
                onChange={(e) => setSpecial(e.target.checked)}
                type="checkbox"
                className="toggle toggle-primary"
              />
              <span className="label-text">مهمان خاص</span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Guest;
